import { delay, put, select } from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';

export function* getStaticIpsSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put(actions.getStaticIpsLoading())
     const response = yield axios.get(
        '/getStaticIPSubNets',
       {
        MAC: rMac
       }
      )
      if (response?.status === 200) {
        if (response?.data?.status === 404) {
          // 404 means no subnets configured yet — treat as empty, show Add Subnet UI
          yield put(actions.getStaticIpsSuccess({ message: { subnetDetails: [], subnetHeader: {} } }));
        } else {
          yield put(actions.getStaticIpsSuccess(response?.data));
        }
      } else {
        yield put(actions.getStaticIpsFail());
      }
    } catch (error) {
      if (error?.response?.status === 404 || error?.response?.data?.status === 404) {
        yield put(actions.getStaticIpsSuccess({ message: { subnetDetails: [], subnetHeader: {} } }));
      } else {
        yield put(actions.setUpstreamError());
      }
    }
  }
}
export function* deleteStaticIpInfoDetailsSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      const axiosConfig = {
        method: 'delete',
        url: '/deleteSubNet',
        params: {
          rMac,
          subnetId: action.info.subnetId,
          sessionToken
        }
      }
      const response = yield axios(axiosConfig);
      if (response.status === 200) {
          yield action.info.callback({ success: true })
          yield put(actions.deleteStaticIpSuccess(action.info))
          yield put(actions.getStaticIps());
          yield put(actions.refreshDevices())
      } else {
            yield action.info.callback({ failure: true })
            yield put(actions.deleteStaticIpFailed());
        }
       
    } catch (error) {
      yield put(yield put(actions.deleteStaticIpFailed()));
      yield action.info.callback({ failure: true })
    }
  } else {
    yield put(yield put(actions.deleteStaticIpFailed()));
    yield action.info.callback({ failure: true })
  }
}


export function* setStaticIpSaga(action) {
  const rMac = yield sessionStorage.getItem('mac');
  const token = yield sessionStorage.getItem('token');
  const sessionToken = yield sessionStorage.getItem('sessionToken');
  if (sessionToken) {
    try {
      yield put(actions.getStaticIpsLoading())
     const response = yield axios.post(
        '/addSubNet',
       {
        rMac, 
        ...action.payload || {}
       }
      )
      if (response?.data.status === 200) {
        yield put(actions.setStaticIpSuccess(response?.data));
      } else if (response?.data?.status === 404) {
        yield put(actions.setUpstreamError());
      } else {
        yield put(actions.setStaticIpFail());
        yield put(actions.setStaticIpsFailedMessage(response.data.message))
      }
    } catch (error) {
      yield put(actions.setUpstreamError());
    }
  }
}
